export const adminEventAdditionalInstructions = (params: { eventId: number }) => `event:${params.eventId}`;
